<template>
  <div class="progressor-wrapper" :style="{ width, height }">
    <div
      class="progressor variant"
      :data-variant="variant"
      data-apply-color
      data-apply-bg-gradient
      :style="{ transform: `translateX(-${completed > 100 ? 0 : 100 - completed}%)`, height }"
    ></div>
  </div>
</template>

<script>
export default {
  name: 'ProgressBar',
  props: {
    completed: Number,
    variant: String,
    width: {},
    height: {
      default: '3px'
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/goals';

.progressor-wrapper {
  box-shadow: inset 0px 1px 2px rgba(138, 138, 138, 0.5);
  border-radius: 8px;
  overflow: hidden;
  position: relative;
}
.progressor {
  position: absolute;
  left: 0;
  right: 0;
  transition: transform 200ms linear;
}
</style>
